import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PageService} from '../../../page/services/page.service';

@Component({
  selector: 'app-multiple-search-bastidor-modal',
  templateUrl: './multiple-search-bastidor-modal.component.html',
  styleUrls: ['./multiple-search-bastidor-modal.component.css']
})
export class MultipleSearchBastidorModalComponent implements OnInit {

  numBastidor = '' ;
  bastidores: string [] = [];

  constructor(public dialogRef: MatDialogRef<MultipleSearchBastidorModalComponent>,
              private pageService: PageService,  @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  addToBastidorToList(): void {

    this.bastidores.push(this.numBastidor);
    this.numBastidor = '';
  }

  removeFromList(i: number): void {
    this.bastidores.splice(i, 1);
  }

}
